/**
 * Logic for handling forms. Handles:
 *  - validation
 *  - ReCaptcha
 */

;(function(jQuery){
	"use strict";
	function ProjectsAbroadForms()
	{
		var global = {
			captchaId: []
		}

		var fn = {
			init: function()
			{
				fn.storeLandingUrl();
				fn.setValidatorRules();
				fn.setHiddenFields();
				fn.initValidator();
				fn.initFloatingLabels();

				if (window.projectsabroadRecaptchaLoaded) {
					fn.initReCaptcha();
				} else {
					window.addEventListener('projectsabroad-captcha-loaded', fn.initReCaptcha);
				}

				//Ensure no dobule-submits
				fn.initBlockDoubleSubmits();
			},

			initReCaptcha: function()
			{
				jQuery('.g-recaptcha').each(function(i, elem){
					var config = jQuery(elem).data();
					var formId = jQuery(this).parents('form').find('form_id').val();
					global.captchaId[formId] = grecaptcha.render(
						elem,
						config
					);
				});
			},

			setValidatorRules: function()
			{
				if ((typeof paFormValidations === 'object') && (paFormValidations !== null)) {
					jQuery.extend( jQuery.validator.messages, paFormValidations );
				}

				jQuery.validator.addMethod('PA_Captcha', function(value, element){
					//This is a bit sneaky - We don't actually look at this element but look at the global recaptcha response.
					var formId = jQuery(element).parents('form').find('form_id').val();
					if ((typeof global.captchaId[formId] == "undefined") || (grecaptcha.getResponse(global.captchaId[formId]) == '')) {
						return false;
					} else {
						return true;
					}
				}, jQuery.validator.messages.paCaptcha);

				jQuery.validator.addClassRules("js-captcha-validation-required", {
					PA_Captcha: true,
				});
			},

			initValidator: function()
			{
				var forms = jQuery('.js-validate');
				forms.each(function(i, form) {

					var rules = {};
					var confirms = jQuery('[name$=_confirm]');
					confirms.each(function(i, elem){
						var name = jQuery(elem).attr('name');
						var match = name.substring( 0, name.indexOf( "_confirm" ) );
						rules[name] = {equalTo: '[name='+match+']'};
					});

					jQuery(form).validate({
						highlight: function(element, errorClass, validClass)
						{
							var target = jQuery(element).parents('.FloatingLabel, .StandardLabel');
							if (target.hasClass('FloatingLabel')) {
								target.addClass('FloatingLabel--error');
							} else {
								target.addClass('StandardLabel--error');
							}
						},
						unhighlight: function(element, errorClass, validClass)
						{
							var target = jQuery(element).parents('.FloatingLabel, .StandardLabel');
							if (target.hasClass('FloatingLabel')) {
								target.removeClass('FloatingLabel--error');
							} else {
								target.removeClass('StandardLabel--error');
							}
						},
						invalidHandler: function(form, validator)
						{
							var errors = validator.numberOfInvalids();
							if (errors) {
								validator.errorList[0].element.focus();
							}
						},
						errorClass: 'Form__error',
						errorPlacement: function(error, element)
						{
							var parent = jQuery(element).parents('.Form__field ');
							parent.find('.Form__error').remove();
							parent.prepend(error);
						},
						rules: rules
					});
				})
			},

			initFloatingLabels: function()
			{
				var fields = jQuery('.FloatingLabel');
				fields.each(function(i, elem){
					fn.floatingLabelChange.bind(elem)();
					jQuery(elem).on('click', fn.floatingLabelClick);
					jQuery(elem).find('input, textarea').on('change keyup keydown focus blur', fn.floatingLabelChange.bind(elem));
				});
			},

			floatingLabelClick: function() {
				jQuery(this).find('input').focus();
			},

			floatingLabelChange: function() {
				var inputs = jQuery(this).find('input, textarea');
				var value = inputs.val().trim();
				if (inputs.is(":focus") || value !== '') {
					jQuery(this).removeClass('is-empty');
				} else {
					jQuery(this).addClass('is-empty');
				}
			},

			initBlockDoubleSubmits: function() {
				jQuery('.js-validate').each(function(i, elem) {
					var form = jQuery(elem);

					var validator = form.data('validator');
					if (validator)
					{
						fn.withBlockValidatorListener(form, validator);
					}

					form.on('submit', fn.onSubmitForm);
					form.on('click', 'button, input[type=submit]', fn.maybeDisableAction);
				});
			},

			/*
			 * If we get a validation error, remove the loading state
			 */
			withBlockValidatorListener: function(form, validator) {
				var oldForm = validator.form;

				validator.form = function()
				{
					var result = oldForm.apply(this, arguments);
					var form   = this.currentForm;

					if (!result)
					{
						// Set a timeout to ensure we run after all other event callbacks have run
						// Otherwise we try and remove the loading display, before it has been added.
						setTimeout(function()
						{
							if (jQuery(form).attr('data-blocked') == 'true')
								fn.removeLoadingDisplay(form);
						});
					}

					return result;
				};
			},

			onSubmitForm: function(e) {
				var form = jQuery(this);
				if (form.attr('data-blocked') == 'true')
					return e.preventDefault();

				var button = form.find('[type=submit]');
				fn.blockSubmit(this);
				fn.addLoadingDisplay(button);
			},

			maybeDisableAction: function(e) {
				var form = jQuery(this).parents('form');
				if (form.attr('data-blocked') == 'true')
					return e.preventDefault();
			},

			blockSubmit: function (form) {
				jQuery(form).attr('data-blocked', true);
			},

			addLoadingDisplay: function (button) {
				var oldContent = jQuery(button).html();
				var newContent = "<div class='js-old-text' hidden>" + oldContent + "</div>";

				jQuery(button).addClass('is-loading').html(newContent);
			},

			removeLoadingDisplay: function(form) {
				var loadings = jQuery(form).find('.is-loading');
				loadings.each(function(i, button) {
					var oldText = jQuery(button).find('.js-old-text');
					if (oldText.length)
					{
						var oldContent = oldText.html();
						jQuery(button).removeClass('is-loading').html(oldContent);
					}
				});

				jQuery(form).attr('data-blocked', 'false');
			},

			setHiddenFields: function() {
				var forms = jQuery('.js-validate');
				if (document.referrer) {
					forms.find('[name=referral_url]').val(document.referrer);
				}
				let gclid = fn.getGclid();
				if (gclid) {
					forms.find('[name=gclid_field]').val(gclid);
				}

				// Sent landing page url from last campaign
				let landingPageUrl = fn.getCookie('pa_landingurl');
				landingPageUrl = landingPageUrl ? encodeURIComponent(landingPageUrl) : '';
				forms.find('[name=landingpage_url]').val(landingPageUrl);
			},

			/**
			 * Requested by DFlaschner (issue #35430 on old websites) .... get gclid from Google Addwords and store in Sales Manager
			 * for this to work in website you have to have the cookie['gclid'] -> this cookie is added by a JavaScript code (probably via GTM)
			 * we also make a check if we have $_GET['gclid'] because if the COOKIE is set on the current page we don't have the cookie set
			 *
			 * @return string gclid
			 */
			getGclid: function() {
				let gclid = false;
				let gclidParam = fn.getParameterByName('gclid');
				let gclsrcParam = fn.getParameterByName('gclsrc');
				if (gclidParam || (gclsrcParam && fn.getParameterByName('gclsrc').indexOf('aw') !== false)) {
					gclid = fn.getParameterByName('gclid');
				} else if (fn.getCookie('gclid')) {
					gclid = fn.getCookie('gclid');
				}

				return gclid;
			},

			getParameterByName: function(name) {
				let url = window.location.href;
				name = name.replace(/[\[\]]/g, '\\$&');
				let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
				let results = regex.exec(url);
				if (!results) {
					return null;
				}
				if (!results[2]) {
					return '';
				}
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			},

			setCookie: function(name, value, days) {
				var d = new Date();
				d.setTime(d.getTime() + (days*24*60*60*1000));
				var expires = "expires="+ d.toUTCString();
				document.cookie = name + "=" + value + ";" + expires + ";path=/";
			},
	
			getCookie: function(name) {
				var value = "; " + document.cookie;
				var parts = value.split("; " + name + "=");
				if (parts.length == 2) return parts.pop().split(";").shift();
			},

			storeLandingUrl: function () { 
				const url = window.location.href;

				if (url.indexOf('utm_campaign') !== -1 || url.indexOf('campaignid') !== -1) { 
					const expiriyDays = 60;
					fn.setCookie('pa_landingurl', url, expiriyDays);
				}
			}
		}

		jQuery(fn.init);
	}

	new ProjectsAbroadForms();
}($));